import FacebookPixel from './FacebookPixel';

export interface FbPixelOptionsShape {
    autoConfig: boolean;
    debug: boolean;
}

export type FbPixelDataShape = {
    content_ids?: object[] | object;
    [key: string]: unknown;
};

export interface FbPixelTrackOptionsShape {
    eventID?: string;
}

/**
 * this version is not compatible with dynamic ads
 */
export interface FbPixelPurchaseDataShape extends FbPixelDataShape {
    content_name?: string;
    content_type?: string;
    contents?: object[];
    currency: string;
    num_items?: number;
    value: number;
}

export interface FbPixelTrialStartDataShape extends FbPixelDataShape {
    currency: string;
    value: number;
    content_type?: string;
    content_name?: string;
    content_category?: string;
    subscription_interval?: string;
}

export default FacebookPixel;
